export const GET_ORDER_ALERTS_SHIP_TOGETHER_REQUEST = 'GET_ORDER_ALERTS_SHIP_TOGETHER_REQUEST';
export const getOrderAlertsShipTogether = (page, pageSize) => ({
  type: GET_ORDER_ALERTS_SHIP_TOGETHER_REQUEST,
  page,
  pageSize,
});

export const GET_ORDER_ALERTS_SHIP_TOGETHER_SUCCESS = 'GET_ORDER_ALERTS_SHIP_TOGETHER_SUCCESS';
export const getOrderAlertsShipTogetherSuccess = (pageData) => ({
  type: GET_ORDER_ALERTS_SHIP_TOGETHER_SUCCESS,
  pageData,
});

export const GET_ORDER_ALERTS_SHIP_TOGETHER_FAILURE = 'GET_ORDER_ALERTS_SHIP_TOGETHER_FAILURE';
export const getOrderAlertsShipTogetherFailure = (err) => ({
  type: GET_ORDER_ALERTS_SHIP_TOGETHER_FAILURE,
  err,
});

export const SET_SELECTED_ALERT_IDS = 'SET_SELECTED_ALERT_IDS';
export const setSelectedAlertIds = (selectedIds) => ({
  type: SET_SELECTED_ALERT_IDS,
  selectedIds,
});

export const ALERT_DISMISSAL_REQUEST = 'ALERT_DISMISSAL_REQUEST';
export const alertDismissalRequest = (alertIds, onSuccessHandler) => ({
  type: ALERT_DISMISSAL_REQUEST,
  alertIds,
  onSuccessHandler,
});

export const ALERT_DISMISSAL_SUCCESS = 'ALERT_DISMISSAL_SUCCESS';
export const alertDismissalSuccess = () => ({
  type: ALERT_DISMISSAL_SUCCESS,
});

export const ALERT_DISMISSAL_FAILURE = 'ALERT_DISMISSAL_FAILURE';
export const alertDismissalFailure = (error) => ({
  type: ALERT_DISMISSAL_FAILURE,
  error,
});

export const GET_SHIP_TOGETHER_ORDERS_REQUEST = 'GET_SHIP_TOGETHER_ORDERS_REQUEST';
export const getShipTogetherOrdersRequest = () => ({
  type: GET_SHIP_TOGETHER_ORDERS_REQUEST,
});

export const GET_SHIP_TOGETHER_ORDERS_SUCCESS = 'GET_SHIP_TOGETHER_ORDERS_SUCCESS';
export const getShipTogetherOrdersSuccess = (orders) => ({
  type: GET_SHIP_TOGETHER_ORDERS_SUCCESS,
  orders,
});

export const SHIP_ORDERS_TOGETHER_FROM_ALERTS = 'SHIP_ORDERS_TOGETHER_FROM_ALERTS';
export const shipOrdersTogetherFromAlerts = () => ({
  type: SHIP_ORDERS_TOGETHER_FROM_ALERTS,
});

export const GET_ORDERS_FOR_SELECTED_ALERTS_REQUEST = 'GET_ORDERS_FOR_SELECTED_ALERTS_REQUEST';
export const getOrdersForSelectedAlertsRequest = () => ({
  type: GET_ORDERS_FOR_SELECTED_ALERTS_REQUEST,
});

export const GET_ORDERS_FOR_SELECTED_ALERTS_SUCCESS = 'GET_ORDERS_FOR_SELECTED_ALERTS_SUCCESS';
export const getOrdersForSelectedAlertsSuccess = (orders) => ({
  type: GET_ORDERS_FOR_SELECTED_ALERTS_SUCCESS,
  orders,
});

export const ORDER_ALERTS_GRID_CHANGE_PAGE = 'ORDER_ALERTS_GRID_CHANGE_PAGE';
export const orderAlertsGridChangePage = (newPage, pageSize) => ({
  type: ORDER_ALERTS_GRID_CHANGE_PAGE,
  newPage,
  pageSize,
});
